import Papa from "papaparse";

export default {
    /**
     * Utilisation de la librairie PapaParse (http://papaparse.com/)
     * @param {*} data csv à convertir en json
     * @param {object} options options de conversion (http://papaparse.com/docs#config)
     */
    csvToJSON(data,options)
    {
        var parsedData = [];

        var defaultOptions = {
            "header":true,
            "dynamicTyping": false,
            "skipEmptyLines": true
        }

        options = options || {};
        options = Object.assign({},defaultOptions,options);
        
        parsedData = Papa.parse(data,options).data;
        
        return parsedData;
    }
};
